import axios from "axios";
import StorageHelper from "./StorageHelper";
import { SIGNIN } from "../configurations/Urls";
import SessionHelper from "./SessionHelper";
import {
  SHOW_STAFF_NOTES,
  STAFF_LOGGED_IN_USER,
  USERNAME,
} from "../configurations/Constants";

const AuthHelper = {
  async SignUp(payload) {
    if (!payload) return;
    const response = await axios.post(`${SIGNIN}/signup`, payload);
    return response;
  },

  async SignIn(username, password, staff) {
    if (!username || !password) return;
    const { data } = await axios.post(SIGNIN, { username, password, staff });
    if (!staff) {
      StorageHelper.setItem(`username`, username);
      StorageHelper.setItem(`${username}.idToken`, data.data.IdToken);
      StorageHelper.setItem(`${username}.accessToken`, data.data.AccessToken);
      StorageHelper.setItem(`${username}.refreshToken`, data.data.RefreshToken);
    } else {
      StorageHelper.setItem(STAFF_LOGGED_IN_USER, username);
      StorageHelper.setItem(`${username}.idToken`, data.data.IdToken);
      StorageHelper.setItem(`${username}.accessToken`, data.data.AccessToken);
      StorageHelper.setItem(`${username}.refreshToken`, data.data.RefreshToken);
    }
    return data;
  },

  async SignInWithToken(reqId) {
    if (!reqId) return;
    sessionStorage.setItem("req_token", reqId);
    StorageHelper.setItem(SHOW_STAFF_NOTES, true);
    const response = await axios.post(SIGNIN, { req_token: reqId });
    return response;
  },

  async resendSignUp(userEmail) {
    if (!userEmail) return;
    const response = await axios.post(`${SIGNIN}/resend/confirmation`, {
      username: userEmail,
    });
    return response;
  },

  async confirmSignUp(username, verificationCode) {
    if (!username || !verificationCode) return;
    const response = await axios.post(`${SIGNIN}/signup/confirm`, {
      username: username,
      confirmation_code: verificationCode,
    });
    return response;
  },

  async changePassword(oldPassword, newPassword) {
    if (!oldPassword || !newPassword) return;
    const username = StorageHelper.getItem(USERNAME);
    const accessToken = StorageHelper.getItem(`${username}.accessToken`);
    const headers = await SessionHelper.getHeaderWithToken();
    const response = await axios.put(
      `${SIGNIN}/password`,
      {
        access_token: accessToken,
        old_password: oldPassword,
        new_password: newPassword,
      },
      { headers: headers }
    );
    return response;
  },

  async ForgotPassword(userEmail) {
    if (!userEmail) return;
    const response = await axios.post(`${SIGNIN}/forgot-password`, {
      username: userEmail,
    });
    return response;
  },

  async ConfirmPassword(payload) {
    if (!payload) return;
    const response = await axios.post(
      `${SIGNIN}/forgot-password/confirm`,
      payload
    );
    return response;
  },

  async SignOut() {
    try {
      const username = StorageHelper.getItem(USERNAME);
      const accessToken = StorageHelper.getItem(`${username}.accessToken`);
      await axios.post(`${SIGNIN}/signout`, { access_token: accessToken });
    } catch (error) {
      return error;
    }
  },
  async StaffSignOut() {
    try {
      const username = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
      const accessToken = StorageHelper.getItem(`${username}.accessToken`);
      await axios.post(`${SIGNIN}/signout`, { access_token: accessToken });
    } catch (error) {
      return error;
    }
  },
  getCurrentSession() {
    const username = StorageHelper.getItem(USERNAME);
    const accessString = `${username}.idToken`;
    const idToken = StorageHelper.getItem(accessString);
    return idToken;
  },
  getCurrentStaffSession() {
    const username = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
    const accessString = `${username}.idToken`;
    const idToken = StorageHelper.getItem(accessString);
    return idToken;
  },
};
export default AuthHelper;
